import * as React from 'react';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';
import { ThemeProviderProps } from 'theming';
import classNames from 'classnames';

import './styles.scss';

import LoadingContent from '../../Components/LoadingContent';
import LoadingApp from '../../Components/LoadingApp';
import Icon from '../../Components/Icon';

export interface IFrameCheckoutProps {
    /** Page title */
    title: string;
    /** Render loader instead of frame itself */
    isLoading?: boolean;
    /** Render loader instead of content */
    isLoadingContent?: boolean;
    /** logo link href */
    logoHref: string;
    /** logo url */
    logoURL?: string;
    /** Render login link */
    login?: {
        /** Button title */
        title: string;
        /** link href */
        href: string;
        /** link click event */
        onClick?: (event) => void;
    };
    /** Userhub component */
    userhub?: React.ReactNode;
    /** Display TimeRemaining bar */
    timeRemaining?: React.ReactNode;
    /** Wrap header for sticky behaviour modifications */
    wrapHeader?: boolean;
}

interface IState {
}

type Props = IFrameCheckoutProps & WithStyles<typeof styles> & ThemeProviderProps<any>;

class FrameCheckout extends React.Component<Props, IState> {
    static displayName: string = 'FrameCheckout';

    componentDidMount () {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.add('global-frame-checkout');
        }
    }

    componentWillUnmount () {
        const doc = document.documentElement;
        if (doc) {
            doc.classList.remove('global-frame-checkout');
        }
    }

    render () {
        if (this.props.isLoading) {
            return <LoadingApp/>;
        }

        const CheckoutNav = () => { return (
            <div className={classNames('frame-checkout-nav', this.props.classes.nav)}>
                <div className="frame-checkout-nav-limiter">
                    <a
                        className="logo"
                        href={this.props.logoHref}
                    >
                        {(this.props.theme && this.props.theme.logoSrc) ? (
                            <img
                                alt={this.props.title}
                                src={this.props.logoURL ? this.props.logoURL : this.props.theme.logoSrc}
                                height={30}
                            />
                        ) : (
                            <Icon width={110} height={30} kind="logo"/>
                        )}
                    </a>
                    {this.props.login && (
                        <a
                            href={this.props.login.href}
                            onClick={this.props.login.onClick}
                            className="login"
                        >
                            <Icon width={18} height={18} kind="login"/>
                            <span className="text">{this.props.login.title}</span>
                        </a>
                    )}
                    {this.props.userhub && this.props.userhub}
                </div>
            </div>
        ); };



        return (
            <div className="frame-checkout">
                {this.props.wrapHeader ? (
                    <div className="frame-checkout-header">
                        {this.props.timeRemaining}
                        {CheckoutNav()}
                    </div>
                ) : (
                    <React.Fragment>
                        {this.props.timeRemaining}
                        {CheckoutNav()}
                    </React.Fragment>
                )}
                <div className="frame-checkout-content">
                    {this.props.isLoadingContent ? <LoadingContent layout="flex"/> : this.props.children}
                </div>
            </div>
        );
    }
}

const styles = (theme) => {
    return {
        '@global': {
            ...(theme.stylesheets ? {
                '@import': [...theme.stylesheets],
            } : {
                '@import': ['url("https://fonts.googleapis.com/css?family=Exo+2:200,200i,300,300i,400,400i,600,600i,700,700i|Titillium+Web:200,200i,300,300i,400,400i,600,600i,700,700i&subset=cyrillic")'],
            }),
            ...theme.global,
        },
        'nav': {
            ...theme.header,
        },
    };
};

export default compose<React.ComponentClass<IFrameCheckoutProps>>(
    withStyles(styles, { injectTheme: true })
)(FrameCheckout);
